// extracted by mini-css-extract-plugin
export default {"foldersWrapper":"folders_foldersWrapper__pzHmw","withList":"folders_withList__MBz2w"};